export default class FormValidator {
  constructor() {
    $(document).on( 'wpformsReady', () => 
    {
      this.customMessages();
     });

    this.messages_pl = {
      required: 'Pole jest wymagane.',
      remote: 'Niepoprawna wartość.',
      email: 'Wprowadź poprawny adres email.',
      number: 'Please enter a valid number.',
    };

    this.messages_en = {
      required: 'This field is required.',
      remote: 'Please fix this field.',
      email: 'Please enter a valid email address.',
      number: 'Please enter a valid number.',
    };

    this.messages_ru = {
      required: 'Pole jest wymagane.',
      remote: 'Niepoprawna wartość.',
      email: 'Wprowadź poprawny adres email.',
    };

    this.messages_au = {
      required: 'Pole jest wymagane.',
      remote: 'Niepoprawna wartość.',
      email: 'Wprowadź poprawny adres email.',
    };
  }

  customMessages() {
    const lang = document.documentElement.lang;
    let message;
    message = this.messages_pl;
    if(lang.includes('en')) message = this.messages_en;
    if(lang.includes('ru')) message = this.messages_ru;
    if(lang.includes('uk')) message = this.messages_ua;
    if (typeof $.fn.validate !== 'undefined') { 
        $.validator.messages.required = message.required;
        $.validator.messages.remote = message.remote;
        $.validator.messages.email = message.email;
        $.validator.messages.number = message.number;
    }
  }
}






// WEBPACK FOOTER //
// ./scripts/components/customFormValidator.js